import RenamePortfolioModal from "./RenamePortfolioModalContainer";

export default RenamePortfolioModal;
